module.exports = __webpack_public_path__ + "img/12217_9.775e2958.png";